import { HomeIcon, PlusCircleIcon } from '@heroicons/react/24/outline';
import { ActionButton } from '@library/components/buttons';
import { PageHeader } from '@library/components/layout/PageHeader';
import { selectHasCreateUnsettlements } from '@bo-selectors/unsettlements/unsettlementsPermissons';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export interface UnselttlementsHeaderProps {
  isHomePage?: boolean;
}
export const UnselttlementsHeader = ({
  isHomePage = false
}: UnselttlementsHeaderProps) => {
  const navigate = useNavigate();
  const hasCreateUnsettlements = useSelector(selectHasCreateUnsettlements);

  const isCreateDisabled = useMemo(() => {
    return !hasCreateUnsettlements;
  }, [hasCreateUnsettlements]);

  const navLink = useMemo(() => {
    return isHomePage ? (
      <ActionButton
        className="bg-stankonia-100"
        dataTestId="create-new-unsettlement"
        disabled={isCreateDisabled}
        handleOnClick={() => navigate('/unsettlements/new')}
        title="Create new unsettlement"
      >
        <PlusCircleIcon
          className={`${isCreateDisabled ? 'text-soClean-180' : 'text-soClean-100'} mr-2 size-5`}
        />
        <span>Create new unsettlement</span>
      </ActionButton>
    ) : (
      <ActionButton
        dataTestId="return-to-unsettlements-home"
        handleOnClick={() => navigate('/unsettlements')}
        title="Return to unsettlements"
        variant="secondary"
      >
        <HomeIcon className="text-soClean-100 mr-2 size-4" />
        <span>Return to home</span>
      </ActionButton>
    );
  }, [isCreateDisabled, isHomePage, navigate]);

  return (
    <PageHeader moduleName="Unsettlements" title="Unsettlements">
      {hasCreateUnsettlements && navLink}
    </PageHeader>
  );
};
